import React from "react";
import { IoArrowBack, IoArrowForward, IoSaveOutline } from "react-icons/io5";
import Header from "./Header";
import Footer from "./Footer";

const HraAssessmentShell = ({
  stepIndex,
  totalSteps,
  stepLabel,
  onSaveExit,
  onBack,
  onNext,
  nextLabel,
  canProceed,
  showBack = true,
  children,
}) => {
  const pct = totalSteps > 0 ? Math.round(((stepIndex + 1) / totalSteps) * 100) : 0;

  return (
    <div className="min-h-screen bg-background flex flex-col pb-16 lg:pb-0">
      <Header />

      <div className="max-w-5xl mx-auto w-full px-3 sm:px-6 pt-4 sm:pt-8 pb-6 flex-1">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4 mb-4 sm:mb-6">
          <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-on-primary-fixed-var">
            Health Risk Assessment
          </h1>
          <button
            type="button"
            onClick={onSaveExit}
            className="btn-outline inline-flex items-center gap-2 text-sm shrink-0 self-start sm:self-center"
          >
            <IoSaveOutline size={16} />
            Save &amp; Exit
          </button>
        </div>

        {totalSteps > 0 && (
          <div className="mb-6 sm:mb-8">
            <div className="h-1.5 bg-surface-container rounded-full overflow-hidden">
              <div
                className="h-full bg-primary rounded-full transition-all duration-300"
                style={{ width: `${pct}%` }}
              />
            </div>
          </div>
        )}

        <div className="bg-surface-lowest border border-surface-container rounded-2xl p-4 sm:p-8 lg:p-10 shadow-sm">
          {children}

          <div className={`flex flex-col-reverse sm:flex-row items-stretch sm:items-center mt-8 sm:mt-10 pt-6 border-t border-surface-container gap-3 sm:gap-0 ${showBack ? "sm:justify-between" : "sm:justify-end"}`}>
            {showBack && (
              <button
                type="button"
                onClick={onBack}
                disabled={stepIndex === 0}
                className={`btn-outline inline-flex items-center justify-center gap-2 text-sm ${
                  stepIndex === 0 ? "opacity-40 cursor-not-allowed" : ""
                }`}
              >
                <IoArrowBack size={16} />
                Back
              </button>
            )}
            <button
              type="button"
              onClick={onNext}
              disabled={!canProceed}
              className={`btn-primary inline-flex items-center justify-center gap-2 text-sm w-full sm:w-auto ${
                !canProceed ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {nextLabel}
              <IoArrowForward size={16} />
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default HraAssessmentShell;